
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/overview",
      function () {
        return require("private-next-pages/customer-studio/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/overview"])
      });
    }
  